// extracted by mini-css-extract-plugin
export default {"badge":"NotificationBadge_badge__cgVRq","circle":"NotificationBadge_circle__pUxpM","announce-ping":"NotificationBadge_announce-ping__MJhCa"};